module.exports = __webpack_public_path__ + "img/logo.38e02d3d.png";